import { render, staticRenderFns } from "./direct-login-not-allowed.vue?vue&type=template&id=749b3d75"
import script from "./direct-login-not-allowed.vue?vue&type=script&lang=js"
export * from "./direct-login-not-allowed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports